import { FC, ReactNode } from 'react';

import { isDefined } from '@hsp/utilities';

import { useSaveButtonConfiguration } from 'pages/audience/shared/save/components/button/hooks';
import { SaveProps } from 'types/pages';

import { DefaultButton } from './components';

const SaveButton: FC<SaveProps> = ({ children, customButton, disabled, features, ...props }) => {
  const { onClick } = useSaveButtonConfiguration({ features, onOpen: props.onOpen });
  let Component: ReactNode;

  if (isDefined(customButton)) {
    Component = <>{customButton({ disabled, onOpen: onClick })}</>;
  } else {
    Component = (
      <DefaultButton
        disabled={disabled}
        {...props}>
        {children}
      </DefaultButton>
    );
  }

  return Component;
};

export default SaveButton;
